import React from "react";
import {observer} from "mobx-react";

import "./legend-item-list.scss";

import {LegendLayerInfoConfiguration} from "../../../../../config/legend-configuration";
import {TopicConfiguration} from "../../../../../config/topic-configuration";
import {LegendLayer} from "./legend-layer/legend-layer";


interface LegendItemListProps {
    topic: TopicConfiguration;
    layerInfos: LegendLayerInfoConfiguration[];
}

@observer
export class LegendItemList extends React.Component<LegendItemListProps, any> {

    constructor(props: LegendItemListProps) {
        super(props);
    }

    componentDidMount(): void {
    }

    componentWillUnmount(): void {
    }

    render(): React.ReactElement | null {
        const legendLayers = this.props.layerInfos.map((layer: LegendLayerInfoConfiguration) => {
            return (<LegendLayer topic={this.props.topic} config={layer} key={layer.id}/>);
        });

        return (
            <div className="geo-legend-item-list">
                {legendLayers}
            </div>
        );

    }
}
